var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _line, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _polygon34, _polygon35;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBatiment1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "batiment_1",
    "data-name": "batiment 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2235 1981",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e6eaed;}.cls-2{fill:#c9ced1;}.cls-3{fill:#dda364;}.cls-4,.cls-9{fill:#c17b53;}.cls-11,.cls-4{opacity:0.35;}.cls-5{fill:#706d7a;}.cls-11,.cls-6{fill:#4b484f;}.cls-7,.cls-8{fill:#b1aaba;}.cls-8{stroke:#4b484f;stroke-width:6px;}.cls-10,.cls-8{stroke-miterlimit:10;}.cls-10{fill:none;stroke:#c17b53;stroke-width:7px;}.cls-12{fill:#302f33;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "batiment 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 1553 740 1981 2235 1120 2235 431 1489 0 1190 173 1042 85 444 432 444.23 606.23 0 864 0 1553"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "68 1593 68 990 668 1331 668 1939.36 68 1593"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1189.17 1720.48 1189 1036 444 606 444 432 1042 85 1788 516 1788 1377.44 1189.17 1720.48"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1189 860 1787.5 515.5 1787.5 1378.5 1562.5 1506.5 1562.5 729.5 1190 946 1189 860"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1188.75 1119.81 820 1331 820 1934.93 740 1981 668.09 1943.51 668 1331 68 990 68 1592.33 0 1553 0 864 444 606 1189 1036 1188.75 1119.81"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "2163 557 2163 1161.47 2235 1120 2235 431 1489 0 1190 173 1788 516 1788 776.74 2163 557"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "820 1416.53 1189 1211.21 1189 1378.82 820 1592.51 820 1416.53"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "820 1768.49 1189 1546.42 1189 1720 820 1935 820 1768.49"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "840 1414.94 1169 1231.88 1169 1381.32 840 1571.84 840 1414.94"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "839.54 1765.55 1169.45 1567 1169.45 1722.19 839.54 1914.42 839.54 1765.55"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1788 852.1 2163 643.45 2163 813.77 1788 1030.94 1788 852.1"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1788 1209.78 2163 984.1 2163 1160.5 1788 1379 1788 1209.78"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1808.33 850.48 2142.68 664.45 2142.68 816.31 1808.33 1009.94 1808.33 850.48"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1807.86 1206.79 2143.14 1005.02 2143.14 1162.73 1807.86 1358.08 1807.86 1206.79"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "518 1331 594 1379 594 1551 518 1508 518 1331"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "518 1593 594 1641 594 1813 518 1770 518 1593"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "330 1270 406 1318 406 1490 330 1447 330 1270"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "330 1532 406 1580 406 1752 330 1709 330 1532"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "143 1113 219 1161 219 1333 143 1290 143 1113"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "143 1375 219 1423 219 1595 143 1552 143 1375"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1190 942 1562 726 1562 1247.9 1189 1461 1190 942"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1190 1547 1562 1338 1562 1503.9 1189 1717 1190 1547"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1189 1036 1189.5 859.5 444.5 431.5 444.5 605.5 1189 1036"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "740 1981 740 1293 0 864 0 1551 68 1593 68 990 668 1331 668 1944 740 1981"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1182.5,
    y1: 887.5,
    x2: 1788,
    y2: 535.69
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "740 1981 740 1294 1189 1036 1188.75 1119.81 820 1331 820 1935 740 1981"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "2235 432 1784.9 691.77 1788 777 2163 557 2162 1161 2235 1120 2235 432"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1635.22 690.13 1716.39 643 1716.39 812.52 1635 859.02 1635.22 690.13"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1635.22 950.13 1716.39 903 1716.39 1072.53 1635 1119.02 1635.22 950.13"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1635.22 1297.13 1716.39 1250 1716.39 1419.53 1635 1466.02 1635.22 1297.13"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1187 1547 1788 1211 1788 1119 1186 1466 1187 1547"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1193 1195 1559 993 1558.5 901.02 1193 1115.02 1193 1195"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "1187 1547 1187 1538 1788 1202 1788 1211 1187 1547"
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1186 1475 1186 1466 1788 1119 1788 1127 1186 1475"
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "820 1345.03 1187 1132 1186.65 1121.01 820 1331 820 1345.03"
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1788 791.03 2163 567 2163 557 1788 777 1788 791.03"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatiment1);
export default __webpack_public_path__ + "static/media/batiment_1.bb518b17100b0ea1bf56529e46a371f3.svg";
export { ForwardRef as ReactComponent };